import { Injectable } from '@angular/core';
import { EvcAuthService } from './evc-auth.service';
import { AuthService } from '../../osc-utils/authentication/auth-service';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VantaAuthService {
  public constructor(
    private readonly legacyAuthService: AuthService,
    private readonly authService: EvcAuthService,
  ) { }

  public login(): void {
    return this.getService().login();
  }

  public logout(): void {
    return this.getService().logout();
  }

  public refreshTokens(): Observable<void> {
    return this.getService().refreshTokens();
  }

  public isLoggedIn(): Promise<boolean> {
    return this.getService().isLoggedIn();
  }

  public getIdTokenValue(): string {
    return this.getService().getIdTokenValue();
  }

  private getService(): EvcAuthService | AuthService {
    if (environment.USE_CONNECT_PLATFORM) {
      return this.authService;
    }
    return this.legacyAuthService;
  }
}
